import { render, staticRenderFns } from "./ResendSms.vue?vue&type=template&id=a88e993a&scoped=true"
import script from "./ResendSms.vue?vue&type=script&lang=js"
export * from "./ResendSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88e993a",
  null
  
)

export default component.exports